module.exports = __webpack_public_path__ + "static/media/6.69c105df.jpg";